<template>
  <div class="r-text-body-small text-center">
    <span>אם כבר נרשמת </span>
    <link-button text="הכניסה מכאן" @click="goToLogin"/>
  </div>
</template>

<script>

import LinkButton from '@/components/base/LinkButton';
import { LOGIN_FIRST_PAGE } from '@/router/consts';

export default {
  name: 'GoToLogin',
  components: { LinkButton },
  methods: {
    goToLogin() {
      this.$router.push(LOGIN_FIRST_PAGE);
    },
  },

};
</script>
